import { useSyncExternalStore } from "react";
import { cacheEpoch, cacheScope, subscribeCacheScope } from "@/lib/ui-cache";

/** Changes synchronously when verified identity, role, or impersonation changes. */
export function useCacheScope(): string | null {
  useSyncExternalStore(subscribeCacheScope, cacheEpoch, () => 0);
  return cacheScope();
}
